<template>
  <Dialog :open="open" @close="$emit('close')" headerColor="header" :persistent="false" can-fullscreen>
    <template v-slot:title>
      <FlexColumn full-width>
        <FlexRow v-if="showChatRequestForm">
          <Label text="スカウト送信求人" />
          <Label bold :text="targetJob.name" />
        </FlexRow>
        <ChatRequestForm v-if="showChatRequestForm" :applicant="applicant" @change="handleChange" />
        <FlexRow v-if="showActions">
          <ChatRequestButton v-if="targetJob" :jobId="targetJob.id" :applicant="applicant" :reasons="reasons" :requestorId="requestorId" />
          <ApplicantListAddButton :applicant="applicant" />
          <ApplicantFavoriteAddButton :applicant="applicant" />
          <ApplicantHideButton :applicant="applicant" :hidden="hidden" />
        </FlexRow>
      </FlexColumn>
    </template>
    <template v-slot:default>
      <FlexRow align="start" class="mt-8">
        <FlexColumn width="50%">
          <ApplicantSummaryView :applicant="applicant" />
          <ApplicantBasicCard :applicant="applicant" />
          <ApplicantAcademicCard :applicant="applicant" />
          <ApplicantCareersCard :applicant="applicant" />
        </FlexColumn>
        <FlexColumn width="50%">
          <ApplicantSkillsCard :applicant="applicant" />
          <ApplicantConditionsCard :applicant="applicant" :isSide="isSide" />
          <ApplicantCompetitionsCard :applicant="applicant" />
        </FlexColumn>
      </FlexRow>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "@/components/atoms/Dialog";
import FlexColumn from "@/components/atoms/FlexColumn";
import ChatRequestForm from "@/components/molecules/ChatRequestForm";
import FlexRow from "@/components/atoms/FlexRow";
import ChatRequestButton from "@/components/molecules/ChatRequestButton";
import ApplicantFavoriteAddButton from "@/components/molecules/ApplicantFavoriteAddButton";
import ApplicantListAddButton from "@/components/molecules/ApplicantListAddButton";
import ApplicantSummaryView from "@/components/molecules/ApplicantSummaryView";
import ApplicantBasicCard from "@/components/molecules/ApplicantBasicCard";
import ApplicantAcademicCard from "@/components/molecules/ApplicantAcademicCard";
import ApplicantCareersCard from "@/components/molecules/ApplicantCareersCard";
import ApplicantSkillsCard from "@/components/molecules/ApplicantSkillsCard";
import ApplicantConditionsCard from "@/components/molecules/ApplicantConditionsCard";
import ApplicantCompetitionsCard from "@/components/molecules/ApplicantCompetitionsCard";
import ApplicantHideButton from "@/components/molecules/ApplicantHideButton";
import Label from "@/components/atoms/Label";
export default {
  name: "ApplicantDetailDialog",
  components: {
    Label,
    ApplicantHideButton,
    ApplicantCompetitionsCard,
    ApplicantConditionsCard,
    ApplicantSkillsCard,
    ApplicantCareersCard,
    ApplicantAcademicCard,
    ApplicantBasicCard, ApplicantSummaryView, ApplicantListAddButton, ApplicantFavoriteAddButton, ChatRequestButton, FlexRow, ChatRequestForm, FlexColumn, Dialog},
  props: {
    open: {
      type: Boolean,
      required: true
    },
    targetJob: {
      type: Object
    },
    applicant: {
      type: Object
    },
    showActions: {
      type: Boolean,
      default: false
    },
    requestorId: {
      type: String
    },
  },
  data() {
    return {
      reasons: [],
    }
  },
  computed: {
    hidden() {
      const query = this.$route.query
      const list = query.list
      return list === "hidden"
    },
    isSide() {
      return this.targetJob.isSide
    },
    showChatRequestForm() {
      if (this.targetJob) {
        if (this.showActions) {
          return true
        }
        return this.applicant && this.applicant.chatRequest && this.applicant.chatRequest.reasons && this.applicant.chatRequest.reasons.length > 1
      }
      return false
    }
  },
  methods: {
    handleChange(value) {
      this.reasons = value.reasons
    }
  }
}
</script>

<style scoped>

</style>
